module.exports = __webpack_public_path__ + "static/media/cityleft.09971811.gif";